/* ZOALIN mobile footer social/signup alignment fix - 2026-07-17 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function set(el, styles) {
    if (!el) return;
    Object.keys(styles).forEach(function (key) {
      el.style.setProperty(key, styles[key], 'important');
    });
  }

  function place(el, column, row) {
    set(el, { 'grid-column': column, 'grid-row': row });
  }

  function firstInFooter(footer, selector) {
    var content = footer && footer.querySelector('.footer-content');
    if (!content) return null;
    return content.querySelector(selector);
  }

  function applyFooterAlignment() {
    if (!mq.matches) return;

    Array.prototype.forEach.call(document.querySelectorAll('footer'), function (footer) {
      var content = footer.querySelector('.footer-content');
      if (!content) return;

      var children = Array.prototype.slice.call(content.children);
      var group = children[3];
      var groupContent = group && group.querySelector('.group-block-content');
      var socialHeading = firstInFooter(footer, '.text-block--AemFzTFFqVWl5WUpYR__social_heading');
      var social = firstInFooter(footer, '.social-icons__wrapper');
      var localization = firstInFooter(footer, '.zoalin-localization');
      var email = firstInFooter(footer, '.email-signup-block');
      var newsletter = firstInFooter(footer, '.text-block--AaTNiRFEwc1RWOTgya__newsletter_text');

      set(content, { overflow: 'visible' });
      set(group, { display: 'contents' });
      set(groupContent, { display: 'contents' });

      place(socialHeading, '3', '2');
      set(socialHeading, {
        width: '100%',
        'min-width': '0',
        margin: '0',
        'align-self': 'start',
        'justify-self': 'start',
        'text-align': 'left'
      });
      Array.prototype.forEach.call(socialHeading ? socialHeading.querySelectorAll('h3') : [], function (heading) {
        set(heading, {
          display: 'block',
          margin: '0 0 7px',
          color: '#777',
          'font-size': '7px',
          'font-weight': '700',
          'line-height': '1.15',
          'letter-spacing': '.08em',
          'white-space': 'nowrap',
          'text-align': 'left'
        });
      });

      place(social, '3', '2');
      set(social, {
        display: 'flex',
        'flex-direction': 'row',
        'flex-wrap': 'nowrap',
        'align-items': 'center',
        'justify-content': 'flex-start',
        'justify-self': 'start',
        'align-self': 'start',
        width: 'auto',
        'max-width': '100%',
        margin: '25px 0 0',
        padding: '0',
        gap: '8px',
        overflow: 'visible'
      });
      Array.prototype.forEach.call(social ? social.querySelectorAll('.social-icons__icon-wrapper, .social-icons__icon-wrapper a') : [], function (el) {
        set(el, {
          display: 'inline-flex',
          'align-items': 'center',
          'justify-content': 'center',
          width: '15px',
          'min-width': '15px',
          height: '15px',
          'min-height': '15px',
          margin: '0',
          padding: '0',
          'line-height': '0'
        });
      });
      Array.prototype.forEach.call(social ? social.querySelectorAll('.social-icons__icon') : [], function (el) {
        set(el, {
          display: 'block',
          width: '15px',
          'min-width': '15px',
          height: '15px',
          'min-height': '15px'
        });
      });
      Array.prototype.forEach.call(social ? social.querySelectorAll('.social-icons__icon-label') : [], function (el) {
        set(el, { display: 'none' });
      });

      place(localization, '3', '2');
      set(localization, {
        width: '100%',
        'max-width': '100%',
        margin: '62px 0 0',
        'align-self': 'start',
        'justify-self': 'start'
      });

      place(email, '1 / -1', '3');
      set(email, {
        width: 'min(320px, 86vw)',
        'max-width': '320px',
        'min-height': '48px',
        margin: '18px auto 0',
        'justify-self': 'center'
      });
      Array.prototype.forEach.call(email ? email.querySelectorAll('.email-signup__form') : [], function (el) {
        set(el, {
          display: 'block',
          width: '100%',
          height: 'auto',
          'min-height': '0'
        });
      });
      Array.prototype.forEach.call(email ? email.querySelectorAll('.email-signup__input-group') : [], function (el) {
        set(el, {
          position: 'relative',
          display: 'flex',
          'align-items': 'center',
          width: '100%',
          height: '48px',
          'min-height': '48px',
          margin: '0',
          padding: '0',
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,.52)',
          'border-radius': '999px',
          background: '#000',
          'box-sizing': 'border-box'
        });
      });
      Array.prototype.forEach.call(email ? email.querySelectorAll('.email-signup__input') : [], function (el) {
        set(el, {
          width: '100%',
          'min-width': '0',
          height: '46px',
          'min-height': '46px',
          margin: '0',
          padding: '0 58px 0 22px',
          border: '0',
          'border-radius': '0',
          background: 'transparent',
          color: '#fff',
          'box-shadow': 'none',
          outline: '0',
          'font-size': '8px',
          'line-height': '46px'
        });
      });
      Array.prototype.forEach.call(email ? email.querySelectorAll('.email-signup__button') : [], function (el) {
        set(el, {
          position: 'absolute',
          top: '50%',
          right: '6px',
          transform: 'translateY(-50%)',
          display: 'inline-flex',
          'align-items': 'center',
          'justify-content': 'center',
          width: '38px',
          'min-width': '38px',
          height: '38px',
          'min-height': '38px',
          margin: '0',
          padding: '0',
          border: '0',
          'border-radius': '999px',
          background: 'transparent',
          color: '#fff',
          'box-shadow': 'none'
        });
      });
      Array.prototype.forEach.call(email ? email.querySelectorAll('.email-signup__button-icon') : [], function (el) {
        set(el, {
          display: 'block',
          width: '18px',
          'min-width': '18px',
          height: '18px',
          'min-height': '18px',
          padding: '0'
        });
      });

      if (newsletter) {
        if (newsletter.parentNode) newsletter.parentNode.removeChild(newsletter);
        set(newsletter, {
          display: 'none',
          visibility: 'hidden',
          height: '0',
          'min-height': '0',
          margin: '0',
          padding: '0',
          overflow: 'hidden'
        });
      }
    });
  }

  function scheduleFooterAlignment() {
    applyFooterAlignment();
    window.setTimeout(applyFooterAlignment, 120);
    window.setTimeout(applyFooterAlignment, 650);
    window.setTimeout(applyFooterAlignment, 1800);
    window.setTimeout(applyFooterAlignment, 3400);
  }

  document.addEventListener('DOMContentLoaded', scheduleFooterAlignment);
  window.addEventListener('load', scheduleFooterAlignment);
  if (mq.addEventListener) mq.addEventListener('change', scheduleFooterAlignment);
  else if (mq.addListener) mq.addListener(scheduleFooterAlignment);

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      window.clearTimeout(window.__zoalinFooterAlignmentTimer);
      window.__zoalinFooterAlignmentTimer = window.setTimeout(applyFooterAlignment, 80);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ZOALIN_MOBILE_FOOTER_FIXED_SIZE_FALLBACK_JS_20260720 */
(function () {
  var mq = window.matchMedia('(max-width: 749px), (pointer: coarse) and (orientation: landscape) and (max-height: 760px)');
  var timer = 0;
  function setImportant(el, styles) {
    if (!el) return;
    Object.keys(styles).forEach(function (key) {
      el.style.setProperty(key, styles[key], 'important');
    });
  }
  function place(el, column, row) {
    setImportant(el, { 'grid-column': column, 'grid-row': row });
  }
  function findText(root, text) {
    if (!root) return null;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i += 1) {
      if ((nodes[i].textContent || '').replace(/\s+/g, ' ').indexOf(text) !== -1) return nodes[i];
    }
    return null;
  }
  function topChild(root, el) {
    if (!root || !el) return null;
    var node = el;
    while (node && node.parentElement && node.parentElement !== root) node = node.parentElement;
    return node && node.parentElement === root ? node : el;
  }
  function applyFixedFooterSize() {
    if (!mq.matches) return;
    document.documentElement.setAttribute('data-zoalin-mobile-footer-fixed-size-fallback', '20260720');
    Array.prototype.forEach.call(document.querySelectorAll('footer'), function (footer) {
      var section = footer.querySelector('.section');
      var content = footer.querySelector('.footer-content');
      if (!content) return;
      var children = Array.prototype.slice.call(content.children);
      var brand = children[0];
      var support = topChild(content, findText(content, 'MAY WE HELP YOU?')) || children[1];
      var company = topChild(content, findText(content, 'THE COMPANY')) || children[2];
      var group = children[3];
      var groupContent = group && group.querySelector('.group-block-content');
      var scope = groupContent || group || content;
      var newsletter = topChild(scope, findText(scope, 'SIGN UP FOR ZOALIN UPDATES'));
      var socialHeading = topChild(scope, findText(scope, 'FOLLOW ZOALIN'));
      var social = topChild(scope, scope && scope.querySelector('.social-icons__wrapper'));
      var localization = topChild(scope, scope && scope.querySelector('.zoalin-localization'));
      var email = topChild(scope, scope && (scope.querySelector('.email-signup-block') || scope.querySelector('form') || scope.querySelector('input[type="email"]')));

      setImportant(footer, { background: '#000', color: '#fff', height: 'auto', 'min-height': '0', overflow: 'hidden' });
      setImportant(section, {
        width: '100%',
        'max-width': 'none',
        height: 'auto',
        'min-height': window.innerWidth < 375 ? '430px' : '453px',
        padding: window.innerWidth < 375 ? '62px 18px 46px' : '62px 28px 46px',
        background: '#000',
        'box-sizing': 'border-box',
        'grid-template-columns': 'var(--full-page-grid-with-margins)'
      });
      setImportant(content, {
        contain: 'none',
        'content-visibility': 'visible',
        display: 'grid',
        'grid-column': '2',
        'grid-template-columns': 'minmax(0,.98fr) minmax(0,.98fr) minmax(88px,.74fr)',
        'column-gap': window.innerWidth < 375 ? '13px' : '16px',
        'row-gap': '0',
        width: '100%',
        'max-width': '430px',
        'min-height': '345px',
        margin: '0 auto',
        padding: '0',
        overflow: 'visible',
        'align-items': 'start',
        'justify-content': 'center',
        'text-align': 'left'
      });

      place(brand, '1 / -1', '1');
      setImportant(brand, { width: '100%', margin: '0 auto 36px', 'justify-self': 'center', 'text-align': 'center', 'align-items': 'center', 'justify-content': 'center' });
      Array.prototype.forEach.call(brand ? brand.querySelectorAll('h2') : [], function (h2) {
        setImportant(h2, { display: 'block', width: '100%', margin: '0 auto', color: '#fff', 'font-size': 'clamp(52px, 13vw, 56px)', 'font-weight': '760', 'line-height': '.9', 'letter-spacing': '0', 'text-align': 'center' });
      });
      Array.prototype.forEach.call(brand ? brand.querySelectorAll('p') : [], function (p) {
        setImportant(p, { display: 'none', visibility: 'hidden' });
      });
      place(support, '1', '2');
      place(company, '2', '2');
      setImportant(group, { display: 'contents' });
      setImportant(groupContent, { display: 'contents' });
      if (newsletter && newsletter.parentNode) newsletter.parentNode.removeChild(newsletter);
      place(socialHeading, '3', '2');
      setImportant(socialHeading, { width: '100%', margin: '0', 'text-align': 'left' });
      place(social, '3', '2');
      setImportant(social, { display: 'flex', 'flex-wrap': 'nowrap', 'align-items': 'center', 'justify-content': 'flex-start', gap: '7px', width: 'auto', margin: '23px 0 0', overflow: 'visible' });
      place(localization, '3', '2');
      setImportant(localization, { width: '100%', 'max-width': '100%', margin: '62px 0 0' });
      place(email, '1 / -1', '3');
      setImportant(email, { width: 'min(320px, 86vw)', 'max-width': '320px', height: 'auto', 'min-height': '48px', margin: '22px auto 0', 'justify-self': 'center' });
      Array.prototype.forEach.call(content.querySelectorAll('h3'), function (h3) {
        setImportant(h3, { display: 'block', margin: '0 0 10px', color: '#777', 'font-size': window.innerWidth < 375 ? '6.6px' : '7px', 'font-weight': '760', 'line-height': '1.15', 'letter-spacing': '.08em', 'text-align': 'left', 'text-transform': 'uppercase', 'white-space': 'nowrap' });
      });
      Array.prototype.forEach.call(content.querySelectorAll('p, a, .zoalin-localization, .zoalin-localization *'), function (el) {
        setImportant(el, { color: '#fff', 'font-size': window.innerWidth < 375 ? '6.6px' : '7px', 'line-height': '1.28', 'letter-spacing': '0', 'text-align': 'left' });
      });
      Array.prototype.forEach.call(content.querySelectorAll('.social-icons__icon-wrapper, .social-icons__icon-wrapper a, .social-icons__icon'), function (el) {
        setImportant(el, { width: '15px', 'min-width': '15px', height: '15px', 'min-height': '15px' });
      });
      Array.prototype.forEach.call(content.querySelectorAll('.email-signup__form, .email-signup__input-group'), function (el) {
        setImportant(el, { width: '100%', 'min-height': '48px', height: '48px' });
      });
      Array.prototype.forEach.call(content.querySelectorAll('input[type="email"]'), function (el) {
        setImportant(el, { 'min-height': '46px', height: '46px', 'font-size': '8px', 'padding-left': '22px', 'padding-right': '58px' });
      });
    });
  }
  function schedule() {
    applyFixedFooterSize();
    [80, 260, 900, 1800, 3600].forEach(function (delay) { window.setTimeout(applyFixedFooterSize, delay); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', function () {
    window.clearTimeout(timer);
    timer = window.setTimeout(schedule, 120);
  });
  if (mq.addEventListener) mq.addEventListener('change', schedule);
  else if (mq.addListener) mq.addListener(schedule);
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(applyFixedFooterSize, 90);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ZOALIN_MOBILE_FOOTER_LOGO_LAYOUT_FINAL_JS_20260719 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function important(el, styles) {
    if (!el) return;
    Object.keys(styles).forEach(function (key) {
      el.style.setProperty(key, styles[key], 'important');
    });
  }

  function topChild(root, el) {
    if (!root || !el) return null;
    var node = el;
    while (node && node.parentElement && node.parentElement !== root) {
      node = node.parentElement;
    }
    return node && node.parentElement === root ? node : el;
  }

  function findText(root, text) {
    if (!root) return null;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i += 1) {
      if ((nodes[i].textContent || '').replace(/\s+/g, ' ').indexOf(text) !== -1) return nodes[i];
    }
    return null;
  }

  function place(el, column, row) {
    important(el, { 'grid-column': column, 'grid-row': row });
  }

  function applyFinalFooterLayout() {
    if (!mq.matches) return;

    Array.prototype.forEach.call(document.querySelectorAll('footer'), function (footer) {
      var content = footer.querySelector('.footer-content');
      if (!content) return;

      var children = Array.prototype.slice.call(content.children);
      var brand = children[0];
      var support = topChild(content, findText(content, 'MAY WE HELP YOU?')) || children[1];
      var company = topChild(content, findText(content, 'THE COMPANY')) || children[2];
      var newsletterGroup = children[3];
      var groupContent = newsletterGroup && newsletterGroup.querySelector('.group-block-content');
      var scope = groupContent || newsletterGroup || content;
      var newsletterText = topChild(scope, findText(scope, 'SIGN UP FOR ZOALIN UPDATES'));
      var socialHeading = topChild(scope, findText(scope, 'FOLLOW ZOALIN'));
      var social = topChild(scope, scope && scope.querySelector('.social-icons__wrapper'));
      var localization = topChild(scope, scope && scope.querySelector('.zoalin-localization'));
      var email = topChild(scope, scope && (scope.querySelector('.email-signup-block') || scope.querySelector('form') || scope.querySelector('input[type="email"]')));

      important(content, {
        display: 'grid',
        'grid-template-columns': 'minmax(0,.98fr) minmax(0,.98fr) minmax(88px,.74fr)',
        'column-gap': window.innerWidth < 375 ? '13px' : '16px',
        'row-gap': '0',
        width: '100%',
        'max-width': '430px',
        margin: '0 auto',
        padding: '0',
        overflow: 'visible',
        'align-items': 'start',
        'justify-content': 'center',
        'text-align': 'left'
      });

      place(brand, '1 / -1', '1');
      important(brand, {
        width: '100%',
        margin: '0 auto 36px',
        'justify-self': 'center',
        'text-align': 'center'
      });
      Array.prototype.forEach.call(brand ? brand.querySelectorAll('h2') : [], function (h2) {
        important(h2, {
          display: 'block',
          width: '100%',
          margin: '0 auto',
          color: '#fff',
          'font-size': 'clamp(2.74rem, 13vw, 4rem)',
          'font-weight': '760',
          'line-height': '.9',
          'letter-spacing': '0',
          'text-align': 'center'
        });
      });
      Array.prototype.forEach.call(brand ? brand.querySelectorAll('p') : [], function (p) {
        important(p, { display: 'none' });
      });

      place(support, '1', '2');
      place(company, '2', '2');
      important(newsletterGroup, { display: 'contents' });
      important(groupContent, { display: 'contents' });

      if (newsletterText && newsletterText.parentNode) {
        newsletterText.parentNode.removeChild(newsletterText);
        newsletterText = null;
      }
      important(newsletterText, {
        display: 'none',
        visibility: 'hidden',
        height: '0',
        'min-height': '0',
        margin: '0',
        padding: '0',
        overflow: 'hidden'
      });

      place(socialHeading, '3', '2');
      important(socialHeading, { width: '100%', margin: '0', 'text-align': 'left' });

      place(social, '3', '2');
      important(social, {
        display: 'flex',
        'flex-wrap': 'nowrap',
        'align-items': 'center',
        'justify-content': 'flex-start',
        gap: '7px',
        width: 'auto',
        margin: '23px 0 0',
        overflow: 'visible'
      });

      place(localization, '3', '2');
      important(localization, {
        width: '100%',
        'max-width': '100%',
        margin: '62px 0 0'
      });

      place(email, '1 / -1', '3');
      important(email, {
        width: 'min(320px, 86vw)',
        'max-width': '320px',
        margin: '22px auto 0',
        'justify-self': 'center'
      });

      Array.prototype.forEach.call(content.querySelectorAll('h3'), function (h3) {
        important(h3, {
          margin: '0 0 10px',
          color: '#777',
          'font-size': window.innerWidth < 375 ? '6.6px' : '7px',
          'font-weight': '760',
          'line-height': '1.15',
          'letter-spacing': '.08em',
          'text-align': 'left',
          'text-transform': 'uppercase',
          'white-space': 'nowrap'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('p, a'), function (el) {
        important(el, {
          color: '#fff',
          'font-size': window.innerWidth < 375 ? '6.6px' : '7px',
          'line-height': '1.28',
          'text-align': 'left'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.social-icons__icon-wrapper, .social-icons__icon-wrapper a, .social-icons__icon'), function (el) {
        important(el, {
          width: '15px',
          'min-width': '15px',
          height: '15px',
          'min-height': '15px'
        });
      });
    });
  }

  function schedule() {
    applyFinalFooterLayout();
    window.setTimeout(applyFinalFooterLayout, 160);
    window.setTimeout(applyFinalFooterLayout, 780);
    window.setTimeout(applyFinalFooterLayout, 1800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('load', schedule);
  if (mq.addEventListener) mq.addEventListener('change', schedule);
  else if (mq.addListener) mq.addListener(schedule);
})();
